import { Outlet } from "react-router-dom";
import { TopNavComponent } from "@/components/navigation/top-nav";

export const BaseLayout = () => {
  // TODO: Does this need suspense wrapper?
  return (
    <>
      <TopNavComponent isLogoVisible={true} />
      <Outlet />
    </>
  );
};
